// extracted by mini-css-extract-plugin
export default {"container":"PikoStoryPage_container__GAqIv","header":"PikoStoryPage_header__SARCS","logo":"PikoStoryPage_logo__1czQP","message":"PikoStoryPage_message__d6RwI"};